import styles from "src/components/Business/UsernameTableCell.module.css";
import Avatar from "src/components/Avatar/Avatar";

interface UsernameTableCellProps {
  username?: string;
  fullname?: string;
  email?: string;
}

interface AvatarProps {
  image?: string;
}

/**
 * Renders avatar, username with `@` and fullname (if not `undefined`)
 */
export const UsernameTableCell = ({
  username, fullname, email, image
}: UsernameTableCellProps & AvatarProps) => {
  const tooltip = email ? `${fullname} (${email})` : fullname;

  return (
    <div className={styles.lensID}>
      <Avatar image={image} name={username} className={styles.lensIDAvator} />
      <div className={styles.lensIDUserBlock}>
        <div className={styles.lensIDUsername} title={tooltip}>{`@${username}`}</div>
        {fullname ? <div className={styles.lendIDFullname} title={tooltip}>{fullname}</div> : null}
      </div>
    </div>
  );
};

interface PendingUserTableCellProps {
  email: string;
}

/**
 * For pending user, only show email
 */
export const PendingUserTableCell = ({ email }: PendingUserTableCellProps) => (
  <div className={styles.lensIDEmail}>{email}</div>
);
